import React, { useState, useEffect } from 'react';

const SupplyForm = ({ categories, onSubmit, editingSupply, onSaveSupply, onCancelEdit }) => {
  const [name, setName] = useState('');
  const [unit, setUnit] = useState('');
  const [quantity, setQuantity] = useState('');
  const [supplier, setSupplier] = useState('');
  const [brand, setBrand] = useState('');
  const [totalCost, setTotalCost] = useState('');
  const [unitCost, setUnitCost] = useState(0);
  const [categoryId, setCategoryId] = useState('');
  const [lowStock, setLowStock] = useState('');

  useEffect(() => {
    if (editingSupply) {
      setName(editingSupply.name);
      setUnit(editingSupply.unit);
      setQuantity(editingSupply.quantity?.toString() || '');
      setSupplier(editingSupply.supplier);
      setBrand(editingSupply.brand);
      setTotalCost(editingSupply.totalCost?.toString() || '');
      setCategoryId(editingSupply.categoryId || '');

      // 🔥 FIX CLAVE (soporta ambos nombres)
      setLowStock(
        (editingSupply.lowStock ?? editingSupply.lowStockThreshold ?? '').toString()
      );

    } else {
      setName('');
      setUnit('');
      setQuantity('');
      setSupplier('');
      setBrand('');
      setTotalCost('');
      setCategoryId('');
      setLowStock('');
    }
  }, [editingSupply]);

  useEffect(() => {
    if (quantity && totalCost && parseFloat(quantity) > 0) {
      const calculatedUnitCost = parseFloat(totalCost) / parseFloat(quantity);
      setUnitCost(calculatedUnitCost);
    } else {
      setUnitCost(0);
    }
  }, [quantity, totalCost]);

  const resetForm = () => {
    setName('');
    setUnit('');
    setQuantity('');
    setSupplier('');
    setBrand('');
    setTotalCost('');
    setCategoryId('');
    setLowStock('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !unit || !quantity || !supplier || !brand || !totalCost || !categoryId || lowStock === '') return;

    const supplyData = {
      id: editingSupply ? editingSupply.id : Date.now(),
      name,
      unit,
      quantity: parseFloat(quantity),
      supplier,
      brand,
      totalCost: parseFloat(totalCost),
      unitCost: parseFloat(totalCost) / parseFloat(quantity),
      categoryId: Number(categoryId),

      // 🔥 ESTANDAR FINAL
      lowStock: parseFloat(lowStock)
    };

    if (editingSupply) {
      onSaveSupply(supplyData);
    } else {
      onSubmit(supplyData);
    }

    resetForm();
  };

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow mb-4">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">
        {editingSupply ? 'Editar Insumo' : 'Agregar Insumo'}
      </h3>

      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Nombre</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Nombre del insumo"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Unidad</label>
            <input
              type="text"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
              placeholder="Unidad de medida"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Cantidad</label>
            <input
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              placeholder="Cantidad"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              min="0.01"
              step="0.01"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Proveedor</label>
            <input
              type="text"
              value={supplier}
              onChange={(e) => setSupplier(e.target.value)}
              placeholder="Proveedor"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Marca</label>
            <input
              type="text"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              placeholder="Marca"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Costo Total</label>
            <input
              type="number"
              value={totalCost}
              onChange={(e) => setTotalCost(e.target.value)}
              placeholder="Costo Total"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              min="0.01"
              step="0.01"
              required
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Costo Unitario</label>
            <input
              type="number"
              value={unitCost.toFixed(2)}
              readOnly
              className="w-full px-3 py-2 border border-[#58735A] rounded-md bg-[#F9EFD7] text-[#3F1907]"
            />
          </div>

          <div className="mb-3">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">
              Stock Mínimo (Alerta de Stock Bajo)
            </label>
            <input
              type="number"
              value={lowStock}
              onChange={(e) => setLowStock(e.target.value)}
              placeholder="Cantidad mínima antes de alerta"
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              min="0"
              step="0.01"
              required
            />
          </div>

          <div className="mb-3 md:col-span-2">
            <label className="block text-[#3F1907] text-sm font-bold mb-1">Categoría de Insumo</label>
            <select
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
              className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
              required
            >
              <option value="">Selecciona una categoría</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.name}
                </option>
              ))}
            </select>
          </div>

        </div>

        <button
          type="submit"
          className="w-full bg-[#58735A] hover:bg-[#3F1907] text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200 mt-4"
        >
          {editingSupply ? 'Actualizar Insumo' : 'Guardar Insumo'}
        </button>

        {editingSupply && (
          <button
            type="button"
            onClick={onCancelEdit}
            className="w-full bg-gray-500 hover:bg-gray-600 text-[#F9EFD7] font-medium py-2 px-4 rounded-md transition duration-200 mt-2"
          >
            Cancelar Edición
          </button>
        )}

      </form>
    </div>
  );
};

export default SupplyForm;